export const integrationsApi = (client) => ({
    // ── Arcos outbound config (Settings → Integrations) ───────────────────────
    arcos: {
        get: () => client.get('/api/v1/integrations/arcos').then((r) => r.data),
        save: (body) => client.patch('/api/v1/integrations/arcos', body).then((r) => r.data),
        test: () => client.post('/api/v1/integrations/arcos/test').then((r) => r.data),
    },
    // ── Inbound API keys (machine callers like Arcos) ─────────────────────────
    apiKeys: {
        list: () => client.get('/api/v1/org/api-keys').then((r) => r.data),
        issue: (body) => client.post('/api/v1/org/api-keys', body).then((r) => r.data),
        revoke: (id) => client.post(`/api/v1/org/api-keys/${id}/revoke`).then((r) => r.data),
        remove: (id) => client.delete(`/api/v1/org/api-keys/${id}`).then((r) => r.data),
    },
    // ── Live telemetry snapshots (asset detail page) ──────────────────────────
    iotSnapshots: {
        forAsset: (assetId) => client.get(`/api/v1/integrations/iot-snapshots/${assetId}`).then((r) => r.data),
    },
    // ── Device linking (asset detail page — a human types the IMEI in,
    // unlike Arcos linking which the Arcos platform drives itself) ────────────
    device: {
        link: (assetId, body) => client.post(`/api/v1/integrations/assets/${assetId}/device-link`, body).then((r) => r.data),
        unlink: (assetId) => client.delete(`/api/v1/integrations/assets/${assetId}/device-link`).then((r) => r.data),
    },
    // ── Device-webhook hit log (Settings → MPulse) ─────────────────────────────
    deviceEvents: {
        log: (params) => client.get('/api/v1/integrations/device-events/log', { params }).then((r) => r.data),
    },
    // ── Device webhook endpoints (Settings → MPulse — one URL per device
    // group/vendor, each with its own token baked into the URL) ───────────────
    deviceEndpoints: {
        list: () => client.get('/api/v1/org/device-endpoints').then((r) => r.data),
        issue: (body) => client.post('/api/v1/org/device-endpoints', body).then((r) => r.data),
        revoke: (id) => client.post(`/api/v1/org/device-endpoints/${id}/revoke`).then((r) => r.data),
        remove: (id) => client.delete(`/api/v1/org/device-endpoints/${id}`).then((r) => r.data),
    },
    // ── Integration catalog (Settings → Integrations picker cards; icon +
    // name are super-admin managed, platform-wide) ─────────────────────────────
    catalog: {
        list: () => client.get('/api/v1/integration-catalog').then((r) => r.data),
        rename: (key, displayName) => client.patch(`/api/v1/integration-catalog/${key}`, { display_name: displayName }).then((r) => r.data),
        uploadIcon: (key, file) => {
            const form = new FormData();
            form.append('file', file);
            return client.post(`/api/v1/integration-catalog/${key}/icon`, form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then((r) => r.data);
        },
        resetIcon: (key) => client.delete(`/api/v1/integration-catalog/${key}/icon`).then((r) => r.data),
    },
});
//# sourceMappingURL=integrations.js.map